/**
 * ATTENTION! This file is auto-generated.
 * Generator: packages/platform/server/rpc-generator/generator.ts
 * Any manual changes will be overwritten on the next build.
 *
 * Глобальный реестр всех репозиториев системы.
 * Используйте REPOSITORIES.CRM_LEAD вместо строки 'crm::LeadRepository'.
 */

export const REPOSITORIES = {
  // api-gateway
  API_GATEWAY_EXTERNAL_ACCOUNT: 'api-gateway::ExternalAccountRepository',
  // core
  CORE_ENTITY_TYPE: 'core::EntityTypeRepository',
  CORE_MODULE: 'core::ModuleRepository',
  CORE_OPTION: 'core::OptionRepository',
  CORE_REPOSITORY: 'core::RepositoryRepository',
  CORE_REPOSITORY_ACTION: 'core::RepositoryActionRepository',
  // filemanager
  FILEMANAGER_UPLOADED_FILE: 'filemanager::UploadedFileRepository',
  FILEMANAGER_UPLOADED_FILE_LNK: 'filemanager::UploadedFileLnkRepository',
  FILEMANAGER_FILE_CATEGORY: 'filemanager::FileCategoryRepository',
  FILEMANAGER_FOLDER: 'filemanager::FolderRepository',
  FILEMANAGER_DRIVE_ENTRY: 'filemanager::DriveEntryRepository',
  FILEMANAGER_DRIVE_GROUP: 'filemanager::DriveGroupRepository',
  // identity
  IDENTITY_USER: 'identity::UserRepository',
  IDENTITY_ROLE: 'identity::RoleRepository',
  IDENTITY_RBAC_ACTION: 'identity::RbacActionRepository',
  IDENTITY_RBAC_REPOSITORY: 'identity::RbacRepositoryRepository',
  IDENTITY_ACCESS_TOKEN_LOG: 'identity::AccessTokenLogRepository',
  IDENTITY_REFRESH_TOKEN: 'identity::RefreshTokenRepository',
  IDENTITY_GROUP_TYPE: 'identity::GroupTypeRepository',
  IDENTITY_GROUP: 'identity::GroupRepository',
  // messaging
  MESSAGING_QUEUE_ITEM: 'messaging::QueueItemRepository',
  // notifications
  NOTIFICATIONS_NOTIFICATION: 'notifications::NotificationRepository',
  NOTIFICATIONS_PUSH_SUBSCRIPTION: 'notifications::PushSubscriptionRepository',
  // academy
  ACADEMY_PARTICIPANT: 'academy::ParticipantRepository',
  ACADEMY_DEALER_INVITE: 'academy::DealerInviteRepository',
  ACADEMY_CALL_CHECK: 'academy::CallCheckRepository',
  ACADEMY_SECTION: 'academy::SectionRepository',
  ACADEMY_MODULE: 'academy::ModuleRepository',
  ACADEMY_LESSON: 'academy::LessonRepository',
  ACADEMY_LESSON_PROGRESS: 'academy::LessonProgressRepository',
  ACADEMY_EXAM: 'academy::ExamRepository',
  ACADEMY_QUESTION: 'academy::QuestionRepository',
  ACADEMY_ANSWER_OPTION: 'academy::AnswerOptionRepository',
  ACADEMY_EXAM_ATTEMPT: 'academy::ExamAttemptRepository',
  ACADEMY_ATTEMPT_ANSWER: 'academy::AttemptAnswerRepository',
  ACADEMY_REWARD: 'academy::RewardRepository',
  ACADEMY_REWARD_OPTION: 'academy::RewardOptionRepository',
  ACADEMY_REDEMPTION: 'academy::RedemptionRepository',
  ACADEMY_POINT_ENTRY: 'academy::PointEntryRepository',
  ACADEMY_FAQ: 'academy::FaqRepository',
  // activity
  ACTIVITY_ACTIVITY_THREAD: 'activity::ActivityThreadRepository',
  ACTIVITY_ACTIVITY_EVENT: 'activity::ActivityEventRepository',
  ACTIVITY_ACTIVITY_USER_STATE: 'activity::ActivityUserStateRepository',
  ACTIVITY_ACTIVITY_PIN: 'activity::ActivityPinRepository',
  ACTIVITY_DM_CONVERSATION: 'activity::DmConversationRepository',
  ACTIVITY_PROJECT_TASK: 'activity::ProjectTaskRepository',
  ACTIVITY_TELEGRAM_THREAD_LINK: 'activity::TelegramThreadLinkRepository',
  // avito
  AVITO_AVITO_ACCOUNT: 'avito::AvitoAccountRepository',
  AVITO_AVITO_ITEM: 'avito::AvitoItemRepository',
  AVITO_AVITO_CHAT: 'avito::AvitoChatRepository',
  AVITO_AVITO_MESSAGE: 'avito::AvitoMessageRepository',
  AVITO_AVITO_CALL: 'avito::AvitoCallRepository',
  AVITO_AVITO_SYNC_LOCK: 'avito::AvitoSyncLockRepository',
  // catalog
  CATALOG_PRODUCT_CATALOG: 'catalog::ProductCatalogRepository',
  CATALOG_PRODUCT: 'catalog::ProductRepository',
  CATALOG_BRAND: 'catalog::BrandRepository',
  // comments
  COMMENTS_COMMENT: 'comments::CommentRepository',
  // accounting
  ACCOUNTING_ACCOUNTING_CURRENCY: 'accounting::AccountingCurrencyRepository',
  ACCOUNTING_ACCOUNTING_TAX: 'accounting::AccountingTaxRepository',
  ACCOUNTING_ACCOUNTING_MEASURE: 'accounting::AccountingMeasureRepository',
  ACCOUNTING_ACCOUNTING_LEGAL_ENTITY: 'accounting::AccountingLegalEntityRepository',
  ACCOUNTING_ACCOUNTING_LEGAL_ENTITY_BANK_ACCOUNT: 'accounting::AccountingLegalEntityBankAccountRepository',
  ACCOUNTING_ACCOUNTING_DOCUMENT_TYPE: 'accounting::AccountingDocumentTypeRepository',
  ACCOUNTING_ACCOUNTING_ALLOCATION_TYPE: 'accounting::AccountingAllocationTypeRepository',
  ACCOUNTING_ACCOUNTING_DOCUMENT: 'accounting::AccountingDocumentRepository',
  ACCOUNTING_ACCOUNTING_DOCUMENT_LINE: 'accounting::AccountingDocumentLineRepository',
  ACCOUNTING_ACCOUNTING_DOCUMENT_TRANSACTION: 'accounting::AccountingDocumentTransactionRepository',
  ACCOUNTING_ACCOUNTING_CONTRACT: 'accounting::AccountingContractRepository',
  ACCOUNTING_SUPPLIER_DOC: 'accounting::SupplierDocRepository',
  ACCOUNTING_ORDER_DOC: 'accounting::OrderDocRepository',
  ACCOUNTING_PAY_DOC: 'accounting::PayDocRepository',
  ACCOUNTING_SELL_DOC: 'accounting::SellDocRepository',
  ACCOUNTING_INVOICE_DOC: 'accounting::InvoiceDocRepository',
  ACCOUNTING_INVOICE_DOC_LINE: 'accounting::InvoiceDocLineRepository',
  ACCOUNTING_DOC_TYPE_ATTRIBUTE: 'accounting::DocTypeAttributeRepository',
  ACCOUNTING_DOC_TYPE_ATTRIBUTE_OPTION: 'accounting::DocTypeAttributeOptionRepository',
  ACCOUNTING_DOC_ATTRIBUTE_VALUE: 'accounting::DocAttributeValueRepository',
  ACCOUNTING_ACCOUNTING_WAREHOUSE: 'accounting::AccountingWarehouseRepository',
  ACCOUNTING_STOCK_ENTRY: 'accounting::StockEntryRepository',
  ACCOUNTING_ACCOUNTING_DOCUMENT_STATUS: 'accounting::AccountingDocumentStatusRepository',
  ACCOUNTING_ACCOUNTING_DOCUMENT_EVENT: 'accounting::AccountingDocumentEventRepository',
  ACCOUNTING_ACCOUNTING_DOCUMENT_REFERENCE_TYPE: 'accounting::AccountingDocumentReferenceTypeRepository',
  ACCOUNTING_ACCOUNTING_DOCUMENT_REFERENCE: 'accounting::AccountingDocumentReferenceRepository',
  // crm
  CRM_PARTNER: 'crm::PartnerRepository',
  CRM_PARTNER_ROLE: 'crm::PartnerRoleRepository',
  CRM_PARTNER_ROLE_ATTRIBUTE: 'crm::PartnerRoleAttributeRepository',
  CRM_PARTNER_ROLE_ATTRIBUTE_OPTION: 'crm::PartnerRoleAttributeOptionRepository',
  CRM_PARTNER_ATTRIBUTE_VALUE: 'crm::PartnerAttributeValueRepository',
  CRM_PARTNER_EXTERNAL_ACCOUNT: 'crm::PartnerExternalAccountRepository',
  CRM_SUPPLIERS: 'crm::SuppliersRepository',
  CRM_CONTACT_PERSON: 'crm::ContactPersonRepository',
  CRM_CONTACT_CHANNEL: 'crm::ContactChannelRepository',
  CRM_LEAD: 'crm::LeadRepository',
  CRM_LEAD_REPORT: 'crm::LeadReportRepository',
  CRM_LEAD_VERSION: 'crm::LeadVersionRepository',
  CRM_LEAD_ROW: 'crm::LeadRowRepository',
  CRM_LEAD_ROW_QUOTE: 'crm::LeadRowQuoteRepository',
  CRM_LEAD_STATUS: 'crm::LeadStatusRepository',
  CRM_LEAD_STATUS_TRANSITION: 'crm::LeadStatusTransitionRepository',
  CRM_LEAD_TYPE: 'crm::LeadTypeRepository',
  CRM_LEAD_EVENT: 'crm::LeadEventRepository',
  CRM_PARTNER_EVENT: 'crm::PartnerEventRepository',
  CRM_DEAL: 'crm::DealRepository',
  CRM_DEAL_REPORT: 'crm::DealReportRepository',
  CRM_PARTNER_REPORT: 'crm::PartnerReportRepository',
  CRM_PARTNER_DUPLICATES: 'crm::PartnerDuplicatesRepository',
  CRM_MANAGER_REPORT: 'crm::ManagerReportRepository',
  CRM_DEAL_TYPE: 'crm::DealTypeRepository',
  CRM_DEAL_STATUS: 'crm::DealStatusRepository',
  CRM_DEAL_VERSION: 'crm::DealVersionRepository',
  CRM_DEAL_ROW: 'crm::DealRowRepository',
  CRM_DEAL_ROW_QUOTE: 'crm::DealRowQuoteRepository',
  CRM_WORK_ORDER: 'crm::WorkOrderRepository',
  CRM_DEAL_EVENT: 'crm::DealEventRepository',
  CRM_SALES_AREA: 'crm::SalesAreaRepository',
  CRM_SEGMENT: 'crm::SegmentRepository',
  CRM_TAG: 'crm::TagRepository',
  CRM_SALES_PLAN: 'crm::SalesPlanRepository',
  CRM_SALES_PLAN_ITEM: 'crm::SalesPlanItemRepository',
  CRM_DEAL_TYPE_ATTRIBUTE: 'crm::DealTypeAttributeRepository',
  CRM_DEAL_TYPE_ATTRIBUTE_OPTION: 'crm::DealTypeAttributeOptionRepository',
  CRM_DEAL_ATTRIBUTE_VALUE: 'crm::DealAttributeValueRepository',
  CRM_LEAD_TYPE_ATTRIBUTE: 'crm::LeadTypeAttributeRepository',
  CRM_LEAD_TYPE_ATTRIBUTE_OPTION: 'crm::LeadTypeAttributeOptionRepository',
  CRM_LEAD_ATTRIBUTE_VALUE: 'crm::LeadAttributeValueRepository',
  CRM_PARTNER_STATUS: 'crm::PartnerStatusRepository',
  CRM_LEAD_SOURCE: 'crm::LeadSourceRepository',
  CRM_LOST_REASON: 'crm::LostReasonRepository',
  CRM_CRM_TASK: 'crm::CrmTaskRepository',
  // procurement
  PROCUREMENT_SOURCING_ITEM: 'procurement::SourcingItemRepository',
  PROCUREMENT_SOURCING_OFFER: 'procurement::SourcingOfferRepository',
  PROCUREMENT_SUPPLIER_INVOICE: 'procurement::SupplierInvoiceRepository',
  PROCUREMENT_SUPPLIER_PAYMENT: 'procurement::SupplierPaymentRepository',
  PROCUREMENT_PURCHASE_ORDER: 'procurement::PurchaseOrderRepository',
  // llm
  LLM_LLM_AGENT: 'llm::LlmAgentRepository',
  LLM_LLM_AGENT_RUN: 'llm::LlmAgentRunRepository',
  LLM_LLM_AGENT_RUN_STEP: 'llm::LlmAgentRunStepRepository',
  LLM_LLM_ASSISTANT: 'llm::LlmAssistantRepository',
  LLM_LLM_ASSISTANT_SESSION: 'llm::LlmAssistantSessionRepository',
  LLM_LLM_ASSISTANT_MEMORY: 'llm::LlmAssistantMemoryRepository',
  LLM_LLM_ASSISTANT_MESSAGE: 'llm::LlmAssistantMessageRepository',
  LLM_LLM_ASSISTANT_TOOL_CALL: 'llm::LlmAssistantToolCallRepository',
  LLM_LLM_TOOL: 'llm::LlmToolRepository',
  LLM_LLM_MODEL: 'llm::LlmModelRepository',
  LLM_SESSION_CONTEXT: 'llm::SessionContextRepository',
  // mailer
  MAILER_EMAIL_ACCOUNT: 'mailer::EmailAccountRepository',
  MAILER_EMAIL_ATTACHMENT: 'mailer::EmailAttachmentRepository',
  MAILER_INCOMING_EMAIL: 'mailer::IncomingEmailRepository',
  // northwind
  NORTHWIND_TEST_MOVEMENT: 'northwind::TestMovementRepository',
  // onec
  ONEC_ONEC_EXCHANGE_PROFILE: 'onec::OnecExchangeProfileRepository',
  ONEC_ONEC_EXCHANGE_SESSION: 'onec::OnecExchangeSessionRepository',
  ONEC_ONEC_EXCHANGE_PACKET: 'onec::OnecExchangePacketRepository',
  ONEC_ONEC_EXPORT_ITEM: 'onec::OnecExportItemRepository',
  ONEC_ONEC_EXCHANGE_PACKET_ITEM: 'onec::OnecExchangePacketItemRepository',
  ONEC_ONEC_EXTERNAL_REF: 'onec::OnecExternalRefRepository',
  // tasks
  TASKS_TASK: 'tasks::TaskRepository',
  TASKS_TASK_STATUS: 'tasks::TaskStatusRepository',
  TASKS_TASK_TYPE: 'tasks::TaskTypeRepository',
  // telegram
  TELEGRAM_TELEGRAM_BOT: 'telegram::TelegramBotRepository',
  TELEGRAM_TELEGRAM_USER_BINDING: 'telegram::TelegramUserBindingRepository',
  TELEGRAM_TELEGRAM_PAIRING_TOKEN: 'telegram::TelegramPairingTokenRepository',
  // telephony
  TELEPHONY_TELEPHONY_CONNECTION: 'telephony::TelephonyConnectionRepository',
  TELEPHONY_TELEPHONY_SYNC_STATE: 'telephony::TelephonySyncStateRepository',
  TELEPHONY_TELEPHONY_LINE: 'telephony::TelephonyLineRepository',
  TELEPHONY_TELEPHONY_AGENT: 'telephony::TelephonyAgentRepository',
  TELEPHONY_TELEPHONY_CALL: 'telephony::TelephonyCallRepository',
  TELEPHONY_TELEPHONY_CALL_LINK: 'telephony::TelephonyCallLinkRepository',
  TELEPHONY_TELEPHONY_SYNC_LOCK: 'telephony::TelephonySyncLockRepository',
  // elita
  ELITA_ELITA_PRODUCTS: 'elita::ElitaProductsRepository',
  ELITA_ELITA_SKUS: 'elita::ElitaSkusRepository',
  ELITA_ELITA_CATEGORIES: 'elita::ElitaCategoriesRepository',
  ELITA_ELITA_PRICES: 'elita::ElitaPricesRepository',
  ELITA_ELITA_STOCK: 'elita::ElitaStockRepository',
  ELITA_ELITA_WAREHOUSES: 'elita::ElitaWarehousesRepository',
  ELITA_ELITA_PRICE_TYPES: 'elita::ElitaPriceTypesRepository',
  ELITA_ELITA_REQUISITE_TYPES: 'elita::ElitaRequisiteTypesRepository',
  ELITA_ELITA_PRODUCT_REQUISITES: 'elita::ElitaProductRequisitesRepository',
  ELITA_ELITA_ATTRIBUTES: 'elita::ElitaAttributesRepository',
  ELITA_ELITA_ATTRIBUTE_OPTIONS: 'elita::ElitaAttributeOptionsRepository',
  ELITA_ELITA_ARTICLE_COLOR: 'elita::ElitaArticleColorRepository',
  ELITA_ELITA_DEALS: 'elita::ElitaDealsRepository',
} as const;

/** Union тип всех repository code строк в системе */
export type RepositoryCode = (typeof REPOSITORIES)[keyof typeof REPOSITORIES];
